import { CustomSpin } from '@amili-v3/amili-v3-design';
import { Badge } from 'antd';
import { MenuItemWithBadgeWrapper } from './styles';
import { memo } from 'react';

type MenuItemWithBadgeLabelProps = {
  loading: boolean;
  label: string;
  badgeNumber?: number;
  backgroundColor: string;
};

const MenuItemWithBadgeLabel = ({
  loading,
  label,
  badgeNumber,
  backgroundColor,
}: MenuItemWithBadgeLabelProps) => {
  return (
    <MenuItemWithBadgeWrapper $backgroundColor={backgroundColor}>
      {label}
      {loading ? (
        <CustomSpin spinning={loading} />
      ) : (
        <Badge count={badgeNumber} />
      )}
    </MenuItemWithBadgeWrapper>
  );
};

export default memo(MenuItemWithBadgeLabel);
